import { Icon, Tooltip, useElement } from '@pega/cosmos-react-core';
import React from 'react';
import useLocalTranslation from '../../hooks/useLocalTranslation';

export const ShowEncryptionDisableTooltip: React.FC<any> = () => {
  const [el, setEl] = useElement();

  const translate = useLocalTranslation();
  return (
    <>
      <Icon name="warn-solid" ref={setEl} style={{ color: 'red' }} />
      {el && <Tooltip target={el}>{translate('encryption_disabled_hover_text')}</Tooltip>}
    </>
  );
};
